import React from "react";
import { PasswordGate } from "../../components/PasswordGate";
import { CarpoolPage as CarpoolPageInner } from "./CarpoolPage";

export const CarpoolPage = () => (
  <PasswordGate storageKey="carpool_unlocked">
    <CarpoolPageInner />
  </PasswordGate>
);
